import { Icon } from '@iconify/react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Author } from '../../pieces/Author';
import Avatar from '../../pieces/Avatar';
import { CategoryTitle } from '../../pieces/CategoryTitle';
import { ThreadMenu } from '../../pieces/ThreadMenu';
import { Timestamp } from '../../pieces/Timestamp';

export function Header({
  handleBookmarkButton,
  title,
  userId,
  category,
  createdAt,
  isBookmarked,
}) {
  return (
    <>
      <div className="flex flex-row items-center justify-between">
        <h2 className="text-clip [word-break:break-word]">{title}</h2>
      </div>

      <div className="not-prose mt-2 mb-6 flex flex-row items-center justify-between">
        <div className="flex h-10 items-center gap-2">
          <div className="grid h-10 w-10 place-items-center overflow-hidden rounded-full">
            <Avatar userId={userId} />
          </div>
          <div className="flex flex-col">
            <div className="text-clip line-clamp-1">
              <Author userId={userId} />
            </div>
            <div className="inline-flex items-center gap-1 text-sm opacity-90 sm:text-base">
              <div className="text-clip line-clamp-1">
                <CategoryTitle category={category} />
              </div>
              <div>
                <Icon icon="ci:dot-03-m" />
              </div>
              <Link
                to="."
                className="text-clip line-clamp-1 hover:underline max-[319px]:hidden"
              >
                <Timestamp createdAt={createdAt} />
              </Link>
            </div>
          </div>
        </div>
        <ThreadMenu
          handleBookmarkButton={handleBookmarkButton}
          isBookmarked={isBookmarked}
        />
      </div>
    </>
  );
}

Header.propTypes = {
  title: PropTypes.string.isRequired,
  userId: PropTypes.string.isRequired,
  category: PropTypes.string.isRequired,
  createdAt: PropTypes.string.isRequired,
  handleBookmarkButton: PropTypes.func.isRequired,
  isBookmarked: PropTypes.bool,
};
